import { ResultFormBuilder } from '../../../../common/models/result-form-builder';
import { AmountInCurrencyPipe } from '../../../../common/pipes/amount-in-currency.pipe';
import { DateFullPipe } from '../../../../common/pipes/date-pipes/date-full.pipe';
import { DateShortDatePipe } from '../../../../common/pipes/date-pipes/date-short-date.pipe';
import { FieldOptions } from '../../../../ui/controls/field.model';
import { ResultCustomFormGroup } from '../../../../ui/custom-reactive-forms/result-custom-form-group';
import { InsuranceSportConfirmDoneData } from '../insurance-sport-create-wizard.model';

export class InsuranceSportCreateWizardResultForm extends ResultFormBuilder<InsuranceSportConfirmDoneData> {

	public buildResultForm(resultData: InsuranceSportConfirmDoneData): ResultCustomFormGroup {

		const resultForm: ResultCustomFormGroup = new ResultCustomFormGroup({});

		resultForm.addCustomControlOnFieldOptions(
			new FieldOptions({
				'@type': 'label-field',
				name: 'operationType',
				label: 'Тип операции',
				value: 'Перевод в оплату страхового полиса',
			}),
		);

		resultForm.addCustomControlOnFieldOptions(
			new FieldOptions({
				'@type': 'label-field',
				name: 'operationTime',
				label: 'Время операции',
				value: new DateFullPipe().transform(
					resultData.operationTime,
				),
			}),
		);

		resultForm.addCustomControlOnFieldOptions(
			new FieldOptions({
				'@type': 'label-field',
				name: 'policyValidityPeriod',
				label: 'Период страхования',
				value: `${new DateShortDatePipe().transform(
					resultData.beginDate,
				)} - ${new DateShortDatePipe().transform(
					resultData.endDate,
				)}`,
			}),
		);

		resultForm.addCustomControlOnFieldOptions(
			new FieldOptions({
				'@type': 'label-field',
				name: 'insuredSports',
				label: 'Виды спорта',
				value: resultData.insuredSports.join(', '),
			}),
		);

		resultForm.addCustomControlOnFieldOptions(
			new FieldOptions({
				'@type': 'label-field',
				name: 'insuranceRisks',
				label: 'Страховые риски',
				value: resultData.insuranceRisks.join(', '),
			}),
		);

		resultForm.addCustomControlOnFieldOptions(
			new FieldOptions({
				'@type': 'label-field',
				name: 'insuredSum',
				label: 'Страховая сумма на 1го застрахованного',
				value: new AmountInCurrencyPipe().transform(resultData.insuranceSum),
			}),
		);

		for (let i = 0; i < resultData.insuredPersons.length; i++) {
			resultForm.addCustomControlOnFieldOptions(
				new FieldOptions({
					'@type': 'label-field',
					name: `insuredSum${i}`,
					label: `${i + 1}ое застрахованное лицо`,
					value: `${resultData.insuredPersons[i].fio} ${new DateShortDatePipe().transform(
						resultData.insuredPersons[i].birthDate,
					)}`,
				}),
			);
		}

		resultForm.addCustomControlOnFieldOptions(
			new FieldOptions({
				'@type': 'label-field',
				name: 'email',
				label: 'Email страхователя',
				value: resultData.clientEmail,
			}),
		);

		resultForm.addCustomControlOnFieldOptions(
			new FieldOptions({
				'@type': 'label-field',
				name: 'premiumSum',
				label: 'Стоимость полиса',
				value: new AmountInCurrencyPipe().transform(resultData.premiumSum),
			}),
		);

		resultForm.addCustomControlOnFieldOptions(
			new FieldOptions({
				'@type': 'label-field',
				name: 'fee',
				label: 'Плата за перевод',
				value: '0.00 ₽',
			}),
		);

		resultForm.addCustomControlOnFieldOptions(
			new FieldOptions({
				'@type': 'label-field',
				name: 'sourceAccountNumber',
				label: 'Со счета',
				value: resultData.sourceAccountNumber,
			}),
		);

		resultForm.addCustomControlOnFieldOptions(
			new FieldOptions({
				'@type': 'label-field',
				name: 'beneficiaryAccountNumber',
				label: 'На счет',
				value: resultData.beneficiaryAccountNumber,
			}),
		);

		resultForm.addCustomControlOnFieldOptions(
			new FieldOptions({
				'@type': 'label-field',
				name: 'beneficiaryBankName',
				label: 'Наименование банка-получателя',
				value: resultData.beneficiaryBankName,
			}),
		);

		return resultForm;
	}

}
